<template>
  <div>
    <v-container class="action-container pa-5" id="revokeDialogue">
      <v-row>
        <v-col
          cols="9"
          md="8"
          lg="6"
          class="text-h6 text-md-h5 text-sm-subtitle-1 text-lg-h5 font-weight-bold"
        >
          <div class="heading-mobile-size">Revoke confirmation</div>
        </v-col>

        <v-col cols="1" md="3" lg="5" class="text-right ml-10">
          <slot name="revokeClose"></slot>
        </v-col>
      </v-row>

      <v-row class="mb-2">
        <v-col cols="11" md="10" lg="10" class="font-weight-bold">
          <div class="question-para-mobile-size">
            <v-icon color="#F1B300" small class="mr-2"
              >fa-solid fa-triangle-exclamation</v-icon
            >

            Are you sure you would like to revoke the selected certificate?
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-2">
        <v-col cols="11">
          <div class="question-para-mobile-size">
            Revoking a certificate will add it to the CRL (Certificate Revocation List)
            and change its state to "Revoked". This action may cause disruptions and is
            irreversible except in the case of "Certificate hold"
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-4">
        <v-col cols="10" md="10" lg="8">
          <div class="question-para-mobile-size">
            Please specify the revocation reason below:
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="9" md="8" lg="6">
          <div>
            <slot name="revokeOptions"></slot>
          </div>
        </v-col>

        <v-col cols="2" md="2" lg="4"
          ><v-icon x-small color="#F44336" class="ml-2 asterisk-mobile-size"
            >fa-asterisk</v-icon
          ></v-col
        >
      </v-row>

      <v-row no-gutters>
        <v-col cols="5" md="7" lg="7"> </v-col>

        <v-col cols="7" md="5" lg="5" class="text-right">
          <slot name="revokeClick"></slot>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <slot name="pendingRevoke"></slot>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  props: ["iconText", "breadText"],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style>
@media only screen and (max-width: 1264px) {
  .heading-mobile-size {
    font-size: 1rem;
    font-weight: 300, bold;
  }
  .question-para-mobile-size {
    font-size: 0.875rem;
    font-weight: 300, bold;
  }
  .asterisk-mobile-size {
    padding-left: 0.5rem !important;
    margin-top: 0.7rem !important;
  }
}
</style>
